import React from 'react';

const Hero = () => {
  return (
    <section className="hero-v2">

      {/* Background decorative circles */}
      <div className="hero-v2-circle hero-v2-circle--tl" />
      <div className="hero-v2-circle hero-v2-circle--br" />

      <div className="hero-v2-inner">

        {/* ── Left column ── */}
        <div className="hero-v2-left">


          <h1 className="hero-v2-title">
            Spurring Innovation in<br />
            <span className="hero-v2-title-accent">Ag, Bio &amp; Food Tech</span>
          </h1>

          <p className="hero-v2-subtitle">
            Bridging academia, industry, and growers to accelerate agtech solutions from lab to field.
          </p>

          <div className="hero-v2-buttons">
            <a href="#programs" className="hero-v2-btn-primary">
              Explore Programs
            </a>
            <a href="#contact" className="hero-v2-btn-ghost">
              Get Involved →
            </a>
          </div>

          {/* Stats */}
          <div className="hero-v2-stats">
            <div className="hero-v2-stat">
              <span className="hero-v2-stat-num">9</span>
              <span className="hero-v2-stat-label">Startups Supported</span>
            </div>
            <div className="hero-v2-stat-divider" />
            <div className="hero-v2-stat">
              <span className="hero-v2-stat-num">30+</span>
              <span className="hero-v2-stat-label">Grower Partners</span>
            </div>
            <div className="hero-v2-stat-divider" />
            <div className="hero-v2-stat">
              <span className="hero-v2-stat-num">$50K+</span>
              <span className="hero-v2-stat-label">Validation Studies</span>
            </div>
          </div>

        </div>

        {/* ── Right column: Video ── */}
        <div className="hero-v2-right">
          <div className="hero-v2-video-card">
            <div className="hero-v2-video-tag">
              <span className="hero-v2-video-dot" />
              AgConverge '25 Highlights
            </div>
            <div className="hero-v2-video-frame">
              <iframe
                src="https://www.youtube.com/embed/JiTeEPC4E6s"
                title="AgConverge '25 Highlights"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <div className="hero-v2-video-footer">
              <span>📍 Gothenburg, Nebraska</span>
              <span>📅 Nov 24, 2025</span>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Hero;